import type React from 'react'
import { CloseIcon } from '../icons'

interface Tag {
	id: string
	label: React.ReactNode
}

interface TagsProps {
	tags: Tag[]
	onRemove?: (tagId: string) => void
}

export const Tags = ({ tags, onRemove = () => {} }: TagsProps) => {
	return (
		<div className='flex flex-wrap gap-2'>
			{tags.map((tag) => (
				<div
					key={tag.id}
					className='flex items-center gap-2 py-1 px-2 rounded-sm text-sm bg-neutral-100 text-neutral-800'>
					<span>{tag.label}</span>
					<button
						type='button'
						onClick={() => onRemove(tag.id)}
						className='p-1 h-auto w-auto bg-neutral-200 cursor-pointer'>
						<CloseIcon />
					</button>
				</div>
			))}
		</div>
	)
}
